import React from 'react';
import { Image } from 'react-bootstrap';
import MarkerImg from '../assets/img/marker_img.svg';
import CancelIcon from '../assets/img/cancel.svg';
import { checkNullValue, getTaskName } from '../utils/Util';
import moment from 'moment';
export interface IMarkerToolTipProps {
  address?: string;
  setShowToolTip: (show: boolean) => void;
  showToolTip: boolean;
  data: any;
  distanceTravelledAndTime?: string;
  indexNumber: number;
  label?: string | number;
}
const MarkerToolTip = ({
  address,
  data,
  showToolTip,
  setShowToolTip,
  distanceTravelledAndTime,
  indexNumber,
  label,
}: IMarkerToolTipProps) => {
  return (
    <>
      {!showToolTip && (
        <div className="polly-marker-parent">
          <Image
            src={MarkerImg}
            className="polly-marker"
            alt="markerImage"
            onClick={() => {
              setShowToolTip(true);
            }}
          />
          <span className="marker-label">{label}</span>
        </div>
      )}
      {showToolTip && (
        <div className="tool-tip-parent">
          <div className="d-flex  tool-tip-header">
            <span>Task: {getTaskName(data)}</span>
            <Image
              src={CancelIcon}
              className="ms-auto"
              alt="cancel"
              onClick={() => {
                setShowToolTip(false);
              }}
            />
          </div>

          <div className="tool-tip-des">
            Distance Traveled / Travel Time:
            {checkNullValue(distanceTravelledAndTime)}{' '}
            {/* {checkNullValue(data.travelTime)}. */}
          </div>
          <div className="tool-tip-des">
            Date Time:{' '}
            {moment(data?.locationReceivedAt).format('DD MMM YYYY, hh:mm A')}
          </div>
          <div className="tool-tip-des">
            Last Location: {checkNullValue(address)}
          </div>
          <div className="polly-marker-parent-tool-tip">
            <Image src={MarkerImg} className="polly-marker-tool-tip " />
          </div>
        </div>
      )}
    </>
  );
};

export default MarkerToolTip;
